<template>
  <div class="wrapper">
    <div class="banner">
      <div>
        <h2>
          {{ $t("pages.offer.subtitle") }}
        </h2>
        <h1>{{ $t("pages.offer.subtitleBold") }}</h1>
        <one-button
          type="primary"
          @click.native="to1HomePage"
        >
          {{ $t("pages.offer.btn") }}
        </one-button>
      </div>
      <div>
        <img class="banner-img" src="@/assets/1home-hero.png" alt="1Home devices" />
      </div>
    </div>
    <div class="testimonials-wrapper shadow">
      <h3>{{ $t("pages.offer.testimonials.title") }}</h3>
      <div class="testimonials">
        <div class="">
          <img class="avatar" src="@/assets/stephan-schambach.png" alt="avatar" />
          <div>
            <p>{{ $t("pages.offer.testimonials.text1") }}</p>
            <h4>KNX</h4>
            <h5>{{ $t("pages.offer.testimonials.name1") }}</h5>
          </div>
        </div>
        <div class="">
          <img class="avatar" src="@/assets/david-darmanin.png" alt="avatar" />
          <div>
            <p>{{ $t("pages.offer.testimonials.text2") }}</p>
            <h4>Loxone</h4>
            <h5>{{ $t("pages.offer.testimonials.name2") }}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { localizeUrl } from "@/utils/localizeUrl";

export default {
  name: "Offer",
  components: {},
  data() {
    return {
    };
  },
  methods: {
    localizeUrl: localizeUrl,
    to1HomePage() {
      window.location = localizeUrl("https://www.1home.io/", this.$i18n.locale);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

h2 {
  text-align: left;
}
h1 {
  font-size: 32px;
  text-align: left;
  color: $color-primary;
}
.banner-img {
  max-height: 330px;
}
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.banner {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.avatar {
  max-height: 150px;
  max-width: 150px;
}
.testimonials-wrapper {
  text-align: center;
  margin-top: 40px;
  padding-top: 20px;
}
.testimonials {
  display: flex;
  flex-direction: row;
  flex: 1 1 0;
  > div {
    display: flex;
    flex-direction: row;
    text-align: left;
    flex: 1 1 0;
    margin: 20px;
    padding: 20px;
    > div {
      margin-left: 20px;
      p {
        font-size: 14px;
      }
    }
  }
}
h4 {
  text-align: left;
  margin-bottom: 0;
  margin-top: 10px;
}
h5 {
  margin: 5px 0;
  color: $color-gray;
  font-size: 12px;
}

@media only screen and (max-width: 1400px) {
  .banner-img {
    max-height: 250px;
  }
  .testimonials-wrapper {
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
    padding: 20px;
  }
  .testimonials {
    display: flex;
    flex-direction: column;
    padding-top: 10px;
    > div {
      align-items: center;
      margin: 0px;
      padding: 20px;
      p {
        margin-bottom: 0;
      }
    }
  }
  h4 {
    margin-top: 10px;
  }
}
@media only screen and (max-width: $screen-md) {
  .banner {
    flex-direction: column;
    justify-content: center;
    text-align: center;
    h2, h1 {
      text-align: center;
    }
    h1 {
      margin-bottom: 20px;
    }
    > div {
      margin-bottom: 30px;
    }
  }
  .testimonials-wrapper {
    margin-top: 10px;
  }
  .banner-img {
    max-width: 100%;
  }
}
@media only screen and (max-width: $screen-sm) {
  .testimonials-wrapper {
    padding: 10px;
  }
  .testimonials {
    > div {
      flex-direction: column;
      > div {
        margin-left: 0;
      }
    }
  }
}
</style>
